import { AuthClientTokens } from './types'

let accessToken: string | null = null
let idToken: string | null = null

export const tokenManager = {
  setTokens(tokens: AuthClientTokens) {
    accessToken = tokens.token ?? null
    idToken = tokens.idToken ?? null
  },
  clearTokens() {
    accessToken = null
    idToken = null
  },
  getAccessToken: () => accessToken,
  getIdToken: () => idToken,
} as const
